import { Model } from 'json-api-models';

import { Models, Schemas } from '../models.ts';

export class Presentation extends Model<Schemas['presentations'], Models> {}
